import { autoinject, bindable, bindingMode, customAttribute, customElement } from 'aurelia-framework';

import { BaseCustomElement } from 'Common/BaseCustomElement';
import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { I18N } from 'aurelia-i18n';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { activationStrategy } from 'aurelia-router';
import { AuthService } from 'DataAccessLayer/Services/AuthService';

@autoinject
export class DatePickerBaseCustomElement extends BaseCustomElement {
    @bindable({ defaultBindingMode: bindingMode.toView }) label: string = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) value: string = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) editable: boolean = true;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) remindersCount: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) columnName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.twoWay }) onChange: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) forceChange: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) tabIndexId: number = -1;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) listOfReminders: Array<any> = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) labelTextForReminder: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) remindersEnabled: boolean = false;

    protected id: string = StringHelper.Empty();
    protected element: any = null;
    protected customElement: any = null;
    protected i18n: I18N = null;
    protected locale: string = null;
    protected authService: AuthService = null;

    constructor(element: Element, i18n: I18N, authService: AuthService) {
        super();

        this.element = element;
        this.i18n = i18n;

        this.id = GuidHelper.NewGuid();
        this.locale = this.i18n.getLocale().toLowerCase().substring(0, 2);
        this.authService = authService;
    }

    bind() {
    }

    async valueChanged(newValue, oldValue) {

    }

    attached() {

    }

    public SetToday() {

    }

    public Clear() {
    }
}
